import "./BindingEdit.0.css";
import { fromPairs } from "lodash-es";
import { vueComponentMixin } from '@tencent/data-schema/lib/vue-ui/definitions';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from '../../../../utils/consts';
import DataPathSelector from '../../../../builtin/designerComponents/DataPathSelector';
const defaultBindingPropSchema = {
  type: 'string'
};
const __script_base__ = {
  // editValue 是由这里注入的，无脑使用即可
  mixins: [vueComponentMixin],
  name: 'PropPanelBindingEdit',
  components: {
    DataPathSelector
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  data() {
    return {
      searchKey: ''
    };
  },
  computed: {
    ...fromPairs(['comp',
    // UICore.Layout
    'compPath',
    // string
    'bindingMeta' // UICore.ComponentBindingMeta
    ].map(x => [x, function () {
      var _this$uiSettings, _this$$attrs;
      return ((_this$uiSettings = this.uiSettings) === null || _this$uiSettings === void 0 ? void 0 : _this$uiSettings[x]) || ((_this$$attrs = this.$attrs) === null || _this$$attrs === void 0 ? void 0 : _this$$attrs[x]);
    }])),
    // eslint-disable-line

    bindingId() {
      return this.bindingMeta.id;
    },
    bindingPropSchema() {
      var _propsSchema$fields;
      const {
        prop
      } = this.bindingMeta;
      if (!prop) return defaultBindingPropSchema;
      const {
        propsSchema
      } = this.uc.components[this.comp.type].meta;
      return (propsSchema === null || propsSchema === void 0 || (_propsSchema$fields = propsSchema.fields) === null || _propsSchema$fields === void 0 ? void 0 : _propsSchema$fields.find(x => x.id === prop)) || defaultBindingPropSchema;
    },
    // 当前绑定值，可读写
    currentDataPath: {
      get() {
        var _this$comp$bindings;
        return (_this$comp$bindings = this.comp.bindings) === null || _this$comp$bindings === void 0 ? void 0 : _this$comp$bindings[this.bindingId];
      },
      set(val) {
        this.applyBinding(val);
      }
    },
    // 生成变量名参考的
    exampleVariableName() {
      return `${this.comp.componentId} ${this.bindingId}`;
    }
  },
  methods: {
    async applyBinding(dataPath) {
      await this.designer.setBinding(this.compPath, this.bindingId, dataPath);
    },
    async deleteBinding() {
      await this.designer.removeBinding(this.compPath, this.bindingId);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-bindingEdit"
  }, [_c("data-path-selector", {
    attrs: {
      filter: _vm.bindingMeta.checkData,
      "example-schema": _vm.bindingPropSchema,
      "example-variable-name": _vm.exampleVariableName
    },
    model: {
      value: _vm.currentDataPath,
      callback: function ($$v) {
        _vm.currentDataPath = $$v;
      },
      expression: "currentDataPath"
    }
  }, [_c("template", {
    slot: "actions"
  }, [_vm.currentDataPath && !_vm.bindingMeta.required ? _c("button", {
    staticClass: "uc-button",
    on: {
      click: _vm.deleteBinding
    }
  }, [_vm._v("\n        解绑\n      ")]) : _vm._e()])], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/PropPanel/DataSchemaComponents/BindingEdit.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);